import { createContext, useContext, useEffect, useState } from "react";
import { http, deviceFingerprint } from "@/api/client";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dds_token");
    if (!token) { setLoading(false); return; }
    http.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("dds_token"); })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const fp = deviceFingerprint();
    const { data } = await http.post("/auth/login", { email, password, device_fingerprint: fp });
    localStorage.setItem("dds_token", data.token);
    setUser(data.user);
    return data.user;
  }

  function logout() {
    localStorage.removeItem("dds_token");
    setUser(null);
  }

  return <AuthCtx.Provider value={{ user, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
